import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {decrement, increment, setUserInfo} from "../store/actions";
import {Button, Divider, Input} from "antd";

const TestRedux = () => {
    const count = useSelector((state) => state.counter.count);  // 获取状态
    const dispatch = useDispatch();  // 获取 dispatch 函数

    const [incrementStep, setIncrementStep] = useState(1); // 增加步长
    const [decrementStep, setDecrementStep] = useState(1); // 减少步长

    const userInfo = useSelector((state) => {
        console.log(JSON.stringify(state.userInfo));  // 打印用户信息
        return state.user.userInfo;
    });
    const [username, setUsername] = useState(userInfo.name); // 从 Redux 中提取初始值
    const [usermark, setUsermark] = useState(userInfo.mark); // 从 Redux 中提取初始值

    // useSelector 的误用：
    // 你在这部分代码中使用了 useSelector 来定义 username 和 usermark 的状态：
    // const [username, setUsername] = useSelector((state) => state.userInfo.name);
    // const [usermark, setUsermark] = useSelector((state) => state.userInfo.mark);
    // useSelector 是一个用于从 Redux store 中提取数据的 hook，它返回的是状态值而不是 setter 函数。而你在这里试图使用它来定义局部的 state 变量，这不是其设计的用途。
    //
    // 应该将 username 和 usermark 的状态管理移到 useState，并从 Redux 中获取数据来初始化它们。


    return (
        <div>
            <h1>Count: {count}</h1>
            <Button onClick={() => dispatch(increment())}>Increment</Button>
            <Button onClick={() => dispatch(decrement())}>Decrement</Button>
            <Divider></Divider>

            <Button onClick={() => dispatch(increment(incrementStep))}>Increment 指定数据</Button>
            <Input value={incrementStep} placeholder="请输入要增加的数量"
                   onChange={(e) => setIncrementStep(Number(e.target.value))} // 更新增加步长
            />
            <Button onClick={() => dispatch(decrement(decrementStep))}>Decrement 指定数据</Button>
            <Input value={decrementStep} placeholder="请输入要减少的数量"
                   onChange={(e) => setDecrementStep(Number(e.target.value))} // 更新增加步长
            />

            <Divider></Divider>
            <h1>userInfo:{JSON.stringify(userInfo)}</h1>
            <Input value={username} placeholder="请输入用户名"
            onChange={(e) => setUsername(e.target.value)}></Input>
            <Input value={usermark} placeholder="请输入用户score"
            onChange={(e) => setUsermark(e.target.value)}></Input>
            <Button onClick={() => {
                dispatch(setUserInfo({name: username, mark: usermark}))
            }}>设置用户信息</Button>
        </div>
    );
}

export default TestRedux;
